import React from 'react';
import AppFlex from 'version-two/components/chakraLayoutOverrides/AppFlex';
import AppAvatar from 'version-two/components/AppAvatar/AppAvatar';
import appColors from 'version-two/theme/appColors';
import AppText from 'version-two/components/Typography/AppText';

function SingleStudentItem({
  image,
  name,
  unlockDate,
  datePreText = 'Unlocked on',
  instanceData,
  handleOnClick,
  disabled,
}) {
  return (
    <AppFlex
      customStyles={{
        justifyContent: 'space-between',
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      variant="moduleAccessList"
      onClick={() => !disabled && handleOnClick(instanceData)}
    >
      <AppFlex
        customStyles={{
          alignItems: 'center',
        }}
      >
        <AppAvatar
          src={image}
          name={name}
          bgColor={appColors.brandSecondary['100']}
          color={appColors.brandSecondary['500']}
          variant="profile"
          size="sm"
        />
        <AppText
          title={`${name}`}
          customStyles={{ ml: 2 }}
          size="sm"
          variant="bold"
        />
      </AppFlex>
      {unlockDate && (
        <AppText
          title={`${datePreText} ${unlockDate}`}
          size="xs"
          color={appColors.brandGrey['500']}
        />
      )}
    </AppFlex>
  );
}

export default React.memo(SingleStudentItem);
